import { createAsyncThunk } from '@reduxjs/toolkit';
import { _patientUrls } from '@custom/Utils/constants/apiUrls';

const patientList = createAsyncThunk('patientList', async (data:any) => {
  let role = localStorage.getItem('role') || sessionStorage.getItem('role');
  
  if (role === 'Government') {
    role = 'government';
  }
  try {
    let url=`${_patientUrls.list}?limit=${data?.pgLimit}&offset=${data?.pageNumber}&patientId=${data.patientId}&hospitalId=${data.hospitalId}&searchQ=${data.searchQ}&from=${role}&fromDate=&endDate=`
    const token = sessionStorage.getItem('token') || localStorage.getItem('token');
    let response = await fetch(url, {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`,
      }
    })
    return await response.json()
  } catch (error) {
    return error;
  }
});

export default patientList;
